/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowArcLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,184a8,8,0,0,1-16,0A87.99083,87.99083,0,0,0,71.69507,116.38086l26.08032,26.08008a8.00064,8.00064,0,0,1-5.65723,13.65722h-64a8.0004,8.0004,0,0,1-8-8v-64a8.00065,8.00065,0,0,1,13.65723-5.65722L60.333,105.01855A104.00326,104.00326,0,0,1,232,184Z" />
    </Svg>
  );
}

export default ArrowArcLeft;
